import React, { Fragment, useState, useEffect } from 'react';
import axios from 'axios';
 
export default function SearchInst() {
  const [data, setData] = useState([]);
  const [query, setQuery] = useState('people walking on street');
  const [name, setName] = useState('natgeotravel');
  const [url, setUrl] = useState(
  	//'http://127.0.0.1:5000/api/v1/search?str=home&name=natgeotravel'
      'https://photosearch-back2.herokuapp.com/api/v1/search?str=people+walking+on+street&name=natgeotravel'
    );

 
    useEffect(() => {
    const fetchData = async () => {
      const result = await axios(url);
 
    setData(result.data);
  };

  fetchData();

  },[url]);
 
  return (

  	<Fragment>
  	  <input
        type="text"
        value={query}
        onChange={event => setQuery(event.target.value)}
      />
  	  <input
        readOnly
        type="texts"
        value={name}
        onChange={event => setName(event.target.value)}
      />
      <button type="button" onClick={() => setUrl(`https://photosearch-back2.herokuapp.com/api/v1/search?str=${query}&name=${name}`)}>
        Search
      </button>

      <div className="card-list">
          {data.map((pic) => (
          <div className="card" key={data.id}>
            <img
              className="card--image"
              src={pic[1]}   
              alt={pic[4]}
              title={pic[2]}
              //src="https://scontent-cdg2-1.cdninstagram.com/v/t51.2885-15/e15/156902706_454653962632548_3122229230439520799_n.jpg?tp=1&_nc_ht=scontent-cdg2-1.cdninstagram.com&_nc_cat=100&_nc_ohc=wA2Qqggs7ckAX8hqngr&oh=68dae6f84bdffe31de173505e54ca1cb&oe=6072A0B9&ig_cache_key=MjUyMzMwMzMwOTQyOTkwMzU1Mw%3D%3D.2"                         
              width="50%"
              height="50%"              
            ></img>

          </div>
        ))}
        </div>

     </Fragment>
  );
}
 
